import React, { Component } from "react";
import print from "../assets/print.png"
import zoom from "../assets/zoom.png"
import download from "../assets/download.png"
import Dropdown from "../components/Dropdown";
import MyInput from "../components/MyInput";


export default class StockSummaryExtras extends Component {
    render() {
        return (
            <div className="dashboard-main">
                <div className="dashboard-top">
                    <div><p className="stock-count">Stock Summary Details</p></div>

                </div>
                <div className="dashboard-bottom">
                    <div> <p className="filter-text">Filters</p></div>
                    <div className="drop-data" style={{ width: "100%", display: "flex", justifyContent: "space-between" }}>
                        <div style={{ width: "52%", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                            <MyInput
                                type="date"
                            />
                            <Dropdown
                                value={"All Stores"}
                            />
                            <MyInput
                                placeholder={"Payload"}
                            ></MyInput>
                        </div>

                        <div>
                            <button className="run-btn"><p className="run-text">Search</p></button>
                        </div>
                    </div>
                    <div style={{ paddingTop: "2%" }}>
                        <table data-table-theme="dark zebra">

                            <thead>

                                <tr style={{ background: "#373E43" }}>
                                    <th >SKU</th>
                                    <th>Quantity</th>


                                </tr>

                            </thead>
                            {
                                Array(1).fill().map(e =>
                                    <tbody>
                                        <tr>
                                            <td>no item</td>

                                        </tr>

                                    </tbody>
                                )
                            }
                        </table>
                    </div>
                </div>
            </div>
        )
    }
}